module.exports = __webpack_public_path__ + "img/1440.8a06a2c5.jpg";